import React from "react";

import "./../../css/alert-box.css";

const SUCCESS_BOX = "success";
//const ERROR_BOX = "error";

export class AlertBoxComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
        // TODO
    }

    render() {
        let icon = "";
        // this.props.icon should be a valid classname of Font Awesome icons
        if (this.props.icon) {
            icon = <icon><i className={this.props.icon} aria-hidden="true"></i></icon>;
        }

        if (this.props.type === SUCCESS_BOX) {
            return <success-box>{icon}<msg>{this.props.message}</msg></success-box>
        } else {
            return <error-box><icon><i className="fa fa-exclamation-triangle" aria-hidden="true"></i></icon><msg>{this.props.message}</msg></error-box>
        }
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Common/AlertBoxComponent.js